import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	chip: {
		borderRadius: 3,
		color: colors.gray[700],
		height: "unset",
		fontSize: 12,
		lineHeight: theme.spacing(0.2)
	},
	label: {
		display: "block",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	}
}))

export default useStyles
